import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { Button, Modal, Form, Input } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined, RetweetOutlined } from '@ant-design/icons';
import BASEURL from '../API/Config';

const { TextArea } = Input;

const RefundPolicy = () => {
  const [list, setList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [existingId, setExistingId] = useState(null);
  const [form] = Form.useForm();
  const token = localStorage.getItem('token');

  const fetchData = async () => {
    try {
      const res = await fetch(`${BASEURL}/master/getrefund`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await res.json();
      setList(Array.isArray(data) ? data : []);
    } catch { Swal.fire('Error', 'Failed to load Refund Policy.', 'error'); }
  };

  useEffect(() => { fetchData(); }, []);

  const openModal = (item = null) => {
    if (item) { setIsEditing(true); setExistingId(item._id); form.setFieldsValue({ name: item.name }); }
    else { setIsEditing(false); setExistingId(null); form.resetFields(); }
    setShowModal(true);
  };

  const handleSubmit = async (values) => {
    try {
      const url = isEditing ? `${BASEURL}/master/updaterefund/${existingId}` : `${BASEURL}/master/createrefund`;
      const res = await fetch(url, {
        method: isEditing ? 'PUT' : 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ name: values.name }),
      });
      if (!res.ok) throw new Error(await res.text());
      Swal.fire('Success', `Refund Policy ${isEditing ? 'updated' : 'saved'}!`, 'success');
      setShowModal(false); fetchData();
    } catch (err) { Swal.fire('Error', err.message || 'Something went wrong.', 'error'); }
  };

  const handleDelete = (id) => {
    Swal.fire({ title: 'Delete Refund Policy?', icon: 'warning', showCancelButton: true, confirmButtonColor: '#e53935', confirmButtonText: 'Yes, Delete' })
      .then(async (r) => {
        if (r.isConfirmed) {
          await fetch(`${BASEURL}/master/deleterefund/${id}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } });
          Swal.fire('Deleted!', 'Removed successfully.', 'success'); fetchData();
        }
      });
  };

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20, flexWrap: 'wrap', gap: 12 }}>
        <div>
          <div style={{ fontSize: 11, fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: 1 }}>Legal & Policies</div>
          <h2 style={{ margin: 0, fontFamily: 'Outfit,sans-serif', fontSize: 22, fontWeight: 700, color: '#212121' }}>Refund Policy</h2>
        </div>
        {list.length === 0 ? (
          <Button type="primary" icon={<PlusOutlined />} onClick={() => openModal()} style={{ background: '#2874f0', borderColor: '#2874f0', borderRadius: 4, height: 38, fontWeight: 600 }}>Add Policy</Button>
        ) : (
          <div style={{ display: 'flex', gap: 8 }}>
            <Button icon={<EditOutlined />} onClick={() => openModal(list[0])} style={{ borderRadius: 4, borderColor: '#2874f0', color: '#2874f0' }}>Edit</Button>
            <Button danger icon={<DeleteOutlined />} onClick={() => handleDelete(list[0]._id)} style={{ borderRadius: 4 }}>Delete</Button>
          </div>
        )}
      </div>
      <div style={{ background: '#fff', borderRadius: 8, border: '1px solid #e8ecf0', boxShadow: '0 1px 4px rgba(0,0,0,0.05)' }}>
        {list.length > 0 ? (
          <div style={{ padding: 24 }}>
            <div style={{ display: 'flex', gap: 14, alignItems: 'flex-start' }}>
              <div style={{ width: 44, height: 44, borderRadius: 10, background: '#e8f1ff', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#2874f0', fontSize: 20, flexShrink: 0 }}><RetweetOutlined /></div>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 600, color: '#374151', marginBottom: 12, fontSize: 14 }}>Refund Policy Content</div>
                <div style={{ fontSize: 14, color: '#4b5563', lineHeight: 1.8, whiteSpace: 'pre-wrap', background: '#f9fafb', padding: 16, borderRadius: 8, border: '1px solid #f0f0f0' }}>{list[0].name}</div>
              </div>
            </div>
          </div>
        ) : (
          <div style={{ padding: 60, textAlign: 'center' }}>
            <RetweetOutlined style={{ fontSize: 48, color: '#d1d5db', display: 'block', marginBottom: 12 }} />
            <div style={{ color: '#9ca3af', fontSize: 14 }}>No Refund Policy added yet.</div>
            <Button type="primary" icon={<PlusOutlined />} onClick={() => openModal()} style={{ marginTop: 16, background: '#2874f0', borderColor: '#2874f0', borderRadius: 4 }}>Add Policy</Button>
          </div>
        )}
      </div>
      <Modal title={<span style={{ fontFamily: 'Outfit,sans-serif', fontWeight: 700 }}>{isEditing ? 'Edit Refund Policy' : 'Add Refund Policy'}</span>}
        open={showModal} onCancel={() => setShowModal(false)} footer={null} centered width={640}>
        <Form form={form} layout="vertical" onFinish={handleSubmit} style={{ marginTop: 16 }}>
          <Form.Item name="name" label="Content" rules={[{ required: true, message: 'Content is required' }]}>
            <TextArea rows={12} placeholder="Enter refund policy content..." style={{ borderRadius: 4, resize: 'none' }} />
          </Form.Item>
          <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
            <Button onClick={() => setShowModal(false)}>Cancel</Button>
            <Button type="primary" htmlType="submit" style={{ background: '#2874f0', borderColor: '#2874f0', borderRadius: 4, fontWeight: 600 }}>{isEditing ? 'Update' : 'Save'}</Button>
          </div>
        </Form>
      </Modal>
    </div>
  );
};

export default RefundPolicy;